export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/service-airport.919ae369-9de49d.png";